import { createGlobalStyle } from 'styled-components';
import theme from './theme';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  body {
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontSizes.base};
    line-height: 1.6;
    color: ${theme.colors.text.primary};
    background-color: ${theme.colors.background.primary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
    box-sizing: border-box;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  /* Reset de elementos */
  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
    margin: 0;
  }

  h1 {
    font-size: ${theme.fontSizes['3xl']};
    font-weight: 700;
  }

  h2 {
    font-size: ${theme.fontSizes['2xl']};
    font-weight: 600;
  }

  h3 {
    font-size: ${theme.fontSizes.xl};
    font-weight: 600;
  }

  h4 {
    font-size: ${theme.fontSizes.lg};
    font-weight: 600;
  }

  h5 {
    font-size: ${theme.fontSizes.base};
    font-weight: 600;
  }

  h6 {
    font-size: ${theme.fontSizes.sm};
    font-weight: 600;
  }

  p {
    margin: 0;
    line-height: 1.6;
  }

  a {
    color: ${theme.colors.primary[500]};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${theme.colors.primary[400]};
    }
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    outline: none;
    transition: all 0.2s ease;
  }

  input, textarea, select {
    font-family: inherit;
    outline: none;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Scrollbar personalizada */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.background.secondary};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.border.primary};
    border-radius: ${theme.borderRadius.full};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.border.secondary};
  }

  /* Estilos para elementos focáveis */
  *:focus-visible {
    outline: 2px solid ${theme.colors.primary[500]};
    outline-offset: 2px;
  }

  /* Estilos para seleção de texto */
  ::selection {
    background-color: ${theme.colors.primary[500]};
    color: ${theme.colors.text.primary};
  }

  /* Estilos para elementos desabilitados */
  :disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* Estilos para elementos de código */
  code {
    font-family: ${theme.fonts.mono};
    background-color: ${theme.colors.background.secondary};
    padding: 0.125rem 0.25rem;
    border-radius: ${theme.borderRadius.sm};
    font-size: 0.875em;
  }

  pre {
    font-family: ${theme.fonts.mono};
    background-color: ${theme.colors.background.secondary};
    padding: 1rem;
    border-radius: ${theme.borderRadius.md};
    overflow-x: auto;
  }

  /* Animações */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }

  /* Classes utilitárias */
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  .slide-in {
    animation: slideIn 0.3s ease-out;
  }

  .pulse {
    animation: pulse 2s infinite;
  }

  /* Responsividade */
  @media (max-width: ${theme.breakpoints.md}) {
    html {
      font-size: 14px;
    }
    
    h1 {
      font-size: ${theme.fontSizes['2xl']};
    }
    
    h2 {
      font-size: ${theme.fontSizes.xl};
    }
  }
`;

export default GlobalStyles;
